module.exports = __webpack_public_path__ + "ot.c668f3c.jpg";